import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ children }) => {
    const { user } = useAuth(); // Use the user state from AuthContext

    return user ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;
